module.exports = __webpack_public_path__ + "static/media/carroussel_19.2a87a2af.jpg";